<template lang="pug">
  app-page(title="Мои заявки" :fab-items="items" v-if="isAppLoaded")

    app-toolbar(title="Заявка на оплату")
    
    addAdvocatAppItem(v-model="dialogAddAdvocatAppItem" :appItem.sync="appItem" @edited="dialogAddAdvocatAppItem = false" @error="forbiddenError = true")
    
    v-snackbar(v-model="forbiddenError" color="red lighten-2" :timeout="6000" vertical bottom) {{forbiddenErrorText}}
      v-btn(light text @click="forbiddenError = false") Закрыть
    
    v-layout(align-start)
      v-flex(xs7 sud-block-overlay)
        .sud-block-title Оказанные услуги по делу {{ advocatApp.courtCase.shortNumber}}
    
            div.mt-4( v-if="advocatApp.advocatAppItems!=null && advocatApp.advocatAppItems.length > 0")
              advocatAppItemCard(
                v-for="(l, index) in advocatApp.advocatAppItems" 
                :key="index" 
                @click.native="selectItem(l)"
                :advocatAppItem="l" :fromAdvocat="true"
              )
            div(v-else)
              v-card
                v-card-title.text-center(plain style="padding-top: 50px;") Наименований нет
    
    
      v-flex(xs5 sud-block-overlay)
        .sud-block-title Заявка по делу {{ advocatApp.courtCase.shortNumber}}
           advocatAppCardIn.mt-4(:advocatApp="advocatApp" :fromAdvocat="true")
               v-layout.justify-space-between.mt-3(v-if="isNotReady")
                  v-btn.text-none(
                    v-if="!hasReject"
                    dark
                    color="#1B93AD" 
                    large depressed 
                    @click="sendApp") Отправить
                  v-btn.text-none(
                    dark
                    color="#ED0E51" 
                    large depressed 
                    @click="deleteApp") Удалить
    
</template>

<script>
import { AppToolbarItemDivider } from '@/components'
import addAdvocatAppItem from './components/AddAdvocatAppItem'
import advocatAppItemCard from './components/AdvocatAppItemCard'
import advocatAppCardIn from './components/AdvocatAppCardIn'

import { mapGetters, mapActions } from 'vuex'

export default {
  components: {
    addAdvocatAppItem,
    advocatAppItemCard,
    advocatAppCardIn
  },
  props: {
    appId: null, 
    addItem: {
        default:false,
        type:Boolean
    }
  },

  created() {
    this.$store.dispatch('advocat/INIT_ITEM', { appId: this.appId })
  },

  mounted() {
    if(this.addItem==true) this.dialogAddAdvocatAppItem = true
    this.ping = setInterval(() => {
      if (this.dialogAddAdvocatAppItem == false) {
        this.refresh({ appId: this.appId })
        .then((data) => {
          if (this.advocatApp.appStatus.value!=data.appStatus.value) {
             this.reset({ app: data})
          }
        })
      }
    }, 10000)
  },

  destroyed () {
    clearInterval(this.ping)
  },

  methods: {
    ...mapActions('advocat', ['refresh', 'reset']),

    selectItem (item) {
      if(this.isNotReady && (item.appStatus.name === "NEW" || item.appStatus.name === "REJECT")){
        this.appItem = item
        this.dialogAddAdvocatAppItem = true
      } else this.forbiddenError=true
    },

    addAppItem () {
      if(this.canAdd){
        this.appItem = null
        this.dialogAddAdvocatAppItem = true
      } else this.forbiddenError=true
    },

    fullName: (pers, type) => {
      if(type=="judge")
        return pers.lastName+" "+pers.firstName+" "+pers.middleName
      else 
        return pers.name
    },
    sendApp() {
      if(this.canSend)
        this.$store.dispatch('advocat/SEND_APP', { appId: this.appId })
      else {
        this.forbiddenErrorText= "Требуется полностью заполненный профиль"
        this.forbiddenError=true
      }
    },
    deleteApp() {
      this.$store.dispatch('advocat/DELETE_APP', { appId: this.appId }).then(() => {
        this.$router.push({name: 'AdvocatApps'})
      })
    }
  },

  computed: {
    items () {
      return this.specialist && this.specialist.moderated 
      ? [AppToolbarItemDivider, {icon:'sud-add-icon sud-add-message', title:'элемент в заявку', action: () => this.addAppItem()}] 
      : []
    },

    ...mapGetters('specialist', ['specialist']),
    ...mapGetters('advocat', ['advocatApp', 'isAppLoaded']),
    isNotReady () {
      return (this.advocatApp.advocatAppItems.length>0 && (this.advocatApp.appStatus.name === "NEW" || this.advocatApp.appStatus.name === "REJECT"))
    },
    canAdd () {
      return (this.advocatApp.appStatus.name === "NEW" || this.advocatApp.appStatus.name === "REJECT")
    },
    hasReject () {
      return this.advocatApp.advocatAppItems.find(j => j.appStatus.name === "REJECT") 
    },
    canSend () {
      if(this.specialist && this.specialist.moderated )
        if((this.specialist.specialistGroup!=null || (this.specialist.bankAccount!=null && this.specialist.bankAccount.bill!='')) 
           && this.specialist.identityCardNumber!=null && this.specialist.identityCardNumber!='' )
          return true
      return false
    },

  },

  data () {
    return {
      dialogAddAdvocatAppItem: false,
      appItem: null,
      forbiddenError: false,
      forbiddenErrorText: "Действия с заявкой запрещены",
      ping: null
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
